<script setup lang="ts">
defineProps<{
  to: string,
  text: string,
}>();

const { queryRefParams } = useHttpReferrer();
</script>

<template>
  <a class="sx-landing-btn default-tag" :href="to + queryRefParams">
    <p>{{ text }}</p>
  </a>
</template>

<style lang="scss">
.sx-landing-btn {
  display: inline-flex;
  align-items: center;
  height: 52px;
  padding: 0 24px;
  border-radius: 26px;
  background: #000;
  color: #fff;
  line-height: 20px;
  flex-shrink: 0;
  font-size: 18px;
  justify-content: center;
  cursor: pointer;
  @media (max-width: 600px) {
    height: 44px;
    padding: 0 16px;
    border-radius: 22px;
    font-size: 16px;
  }

  span {
    line-height: 1;
  }

  &:hover {
    background: #3C3E40;
    color: white;
    border: none;
  }

  &:active {
    background: #545759;
  }
}
</style>
